import { useCallback } from 'react'
import PlusButton from 'core/elements/button/PlusButton'
import { v4 as uuid } from 'uuid'
import { trackEvent } from 'utils/tracking'

export default function AddVolumeBackend({ title = 'Add Volume Type', params, updateParams }) {
  const addVolumeBackendFn = useCallback(() => {
    updateParams({
      volumeBackends: [...params.volumeBackends, { name: '', id: uuid() }],
    })
    trackEvent(`Cluster Blueprint - Clicked Add Volume Type`)
  }, [params.volumeBackends])

  return (
    <PlusButton
      onClick={addVolumeBackendFn}
      label={title}
      data-testid="add-volume-backend-button"
    />
  )
}
